import { createClient } from '@supabase/supabase-js'
import type { Database } from '@db/database.types'
import { env } from './env'

/**
 * The browser client. Every read here goes through row level security,
 * so a query that returns nothing is as likely to be a policy gap as an
 * empty table. When a screen looks empty, check the policy before the
 * data.
 */
export const supabase = createClient<Database>(env.supabaseUrl, env.supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})

export type Tables = Database['public']['Tables']
export type Row<T extends keyof Tables> = Tables[T]['Row']
